import React from 'react';
import s from './ModalSubText.scss';
/** For less emphasized text in modals. e.g. the subtitle */ const ModalSubText = ({ children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, children);
};
ModalSubText.displayName = 'ModalSubText';
export default ModalSubText;
